import { type AxiosResponse } from 'axios'
import { baseApi } from 'entities/Auth'
import type {
  IResponseClient,
  IResponseGetClients,
  IParamsClient,
  IResponsePendingClients,
  IResponsePendingClient,
  IResponseHubSpotTeams,
  IResponseValidateInvite,
  IParamsInviteClient,
  IResponseInviteClient,
} from './types'

class Api {
  getClients(params?: IParamsClient): Promise<AxiosResponse<IResponseGetClients>> {
    return baseApi.get('agency/clients', { params })
  }

  getAllClients(): Promise<AxiosResponse<IResponseClient[]>> {
    return baseApi.get('agency/clients', { params: { all: true } })
  }

  getPendingClients(params?: IParamsClient): Promise<AxiosResponse<IResponsePendingClients>> {
    return baseApi.get('agency/invites', { params })
  }

  renameClient(id: number, name: string): Promise<AxiosResponse<IResponseClient>> {
    return baseApi.post(`agency/clients/${id}`, { name })
  }

  cancelInvite(id: string): Promise<AxiosResponse<void>> {
    return baseApi.delete(`agency/invites/${id}`)
  }

  resendInvite(id: string): Promise<AxiosResponse<IResponsePendingClient>> {
    return baseApi.post(`agency/invites/${id}/resend`)
  }

  getHubSpotTeams(): Promise<AxiosResponse<IResponseHubSpotTeams[]>> {
    return baseApi.get('groups/integration-teams')
  }

  manageHubSpotTeams(id: number, teams: number[]): Promise<AxiosResponse<void>> {
    return baseApi.put(`groups/map-client/${id}`, { integration_team_ids: teams })
  }

  refreshHubSpotTeams(id: number): Promise<AxiosResponse<void>> {
    return baseApi.get('groups/refresh-integration-teams', {
      params: { client_id: id },
    })
  }

  refreshHubSpotTeamsContacts(id: number): Promise<AxiosResponse<void>> {
    return baseApi.get(`groups/refresh-integration-teams-contacts/${id}`)
  }

  validateInvite(email: string): Promise<AxiosResponse<IResponseValidateInvite>> {
    return baseApi.post('agency/invites/validate', { email })
  }

  inviteClient(params: IParamsInviteClient): Promise<AxiosResponse<IResponseInviteClient>> {
    return baseApi.post('agency/invites', params)
  }

  deleteClient(id: number): Promise<AxiosResponse<void>> {
    return baseApi.delete(`agency/clients/${id}?confirm=1`)
  }
}

export const ClientsApi = new Api()
